"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = exports.EmploymentDetails = exports.DueAmount = exports.DueAmounts = exports.Finance = exports.Payment = exports.Fee = exports.User = exports.Customer = exports.PhoneNumber = exports.Privacy = exports.PrivacyFlags = exports.Address = exports.Dealer = exports.Vehicle = exports.Account = void 0;
/* eslint-disable no-unused-vars */
class Account {
}
exports.Account = Account;
class Vehicle {
}
exports.Vehicle = Vehicle;
class Dealer {
}
exports.Dealer = Dealer;
class Address {
}
exports.Address = Address;
class PrivacyFlags {
}
exports.PrivacyFlags = PrivacyFlags;
class Privacy {
}
exports.Privacy = Privacy;
class PhoneNumber {
}
exports.PhoneNumber = PhoneNumber;
class Customer {
}
exports.Customer = Customer;
class User {
}
exports.User = User;
class Fee {
}
exports.Fee = Fee;
class Payment {
}
exports.Payment = Payment;
class Finance {
}
exports.Finance = Finance;
class DueAmounts {
}
exports.DueAmounts = DueAmounts;
class DueAmount {
}
exports.DueAmount = DueAmount;
class EmploymentDetails {
}
exports.EmploymentDetails = EmploymentDetails;
class Application {
}
exports.Application = Application;
//# sourceMappingURL=customer.js.map